import { SecurityGroupsActionType } from './action-types';
import type {
    IRequestSecurityGroupsAction,
    IReceiveSecurityGroupsAction,
    ISecurityGroupsErrorAction,
} from './action-types';

export function requestSecurityGroups(): IRequestSecurityGroupsAction {
    return { type: SecurityGroupsActionType.REQUEST_SECURITY_GROUPS };
}

export function receiveSecurityGroups(groups: string[]): IReceiveSecurityGroupsAction {
    return { type: SecurityGroupsActionType.RECEIVE_SECURITY_GROUPS, groups };
}

export function securityGroupsError(errorMessage?: string): ISecurityGroupsErrorAction {
    return { type: SecurityGroupsActionType.ERROR_SECURITY_GROUPS, errorMessage };
}
